require("core-js/es/map");
require("core-js/es/set");
require("es6-map/implement");
require("es6-promise");
require("es6-object-assign").polyfill();

// Don't remove this. This is used for preventing IE10 to crash.
// We dont call global.crypto.getRandomValues(), but it might be used by an another package, and therefore this polyfill is needed. (Seems to be the "guid" package)
if (!((global as any).crypto && (global as any).crypto.getRandomValues)) {
  require("polyfill-crypto.getrandomvalues")(global as any).crypto = { getRandomValues: require("polyfill-crypto.getrandomvalues") };
}
